import {memo} from 'react';

import type {SVGProps} from 'react';

// Multi-color brand illustration — hardcoded colors are intentional (Figma spec)
export const PropertyHouseIllustration = memo(function PropertyHouseIllustration(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64.0049 64.0049"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.6029 16.669L19.6017 30.8035C18.9349 31.3368 18.6683 32.0035 18.6683 32.8036V57.4722C18.6683 58.9389 19.8683 60.0057 21.2018 60.0057H53.4709C54.9377 60.0057 56.0044 58.8056 56.0044 57.4722V33.0703C56.0044 32.2702 55.7377 31.6035 55.071 31.0701L39.0698 16.669C38.1364 15.7356 36.5363 15.7356 35.6029 16.669Z"
        fill="#FFE082"
      />
      <path
        d="M21.8683 17.5987L31.069 9.33141C31.6024 8.93138 32.4024 8.93138 32.8025 9.33141L57.3377 31.1997"
        stroke="#18193F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66729 31.2031L16.268 22.6691"
        stroke="#18193F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.002 48.0034V39.2028C26.002 38.4027 26.5353 37.8693 27.3354 37.8693H36.6694C37.4695 37.8693 38.0029 38.4027 38.0029 39.2028V55.4707"
        stroke="#18193F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6674 25.7379V52.8066C12.6674 54.2734 13.8675 55.4735 15.3343 55.4735H48.6701C50.1369 55.4735 51.337 54.2734 51.337 52.8066V34.5386"
        stroke="#18193F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.3366 18.6694V14.0024C43.3366 13.2023 43.87 12.6689 44.67 12.6689H50.0038C50.8038 12.6689 51.3372 13.2023 51.3372 14.0024V24.5365"
        stroke="#18193F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0012 62.5622C17.7454 62.5622 22.402 57.9056 22.402 52.1614C22.402 46.4172 17.7454 41.7607 12.0012 41.7607C6.25703 41.7607 1.60044 46.4172 1.60044 52.1614C1.60044 57.9056 6.25703 62.5622 12.0012 62.5622Z"
        fill="#A5D6A7"
        stroke="#1F2150"
        strokeWidth="3"
      />
      <path
        d="M7.20053 52.1611L10.4008 55.3613L16.8013 48.1607"
        stroke="#1F2150"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
